import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetUsers, useGetTeams } from "security-app/hooks/useInvestigationsAPI";
import FilterValueSelect from "views/components/widgets/overview-configuration/filters/FilterValueSelect";
const AssigneeFilter = ({ value = void 0, onSelect, selectedAssignees }) => {
  const { users } = useGetUsers();
  const { teams } = useGetTeams();
  const { t } = useTranslation("enterprise_search");
  const assignToOptions = useMemo(
    () => [
      { value: "Users", label: t("assignee_filter.users"), disabled: true },
      ...users.map((user) => ({
        value: user.id,
        label: user.full_name,
        disabled: selectedAssignees.includes(user.id)
      })).sort((a, b) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      }),
      { value: "Teams", label: t("assignee_filter.teams"), disabled: true },
      ...teams.map((team) => ({
        value: team.id,
        label: team.name,
        disabled: selectedAssignees.includes(team.id)
      })).sort((a, b) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      })
    ],
    [users, teams, selectedAssignees, t]
  );
  return /* @__PURE__ */ React.createElement(
    FilterValueSelect,
    {
      value,
      onChange: onSelect,
      placeholder: t("assignee_filter.placeholder"),
      options: assignToOptions
    }
  );
};
export default AssigneeFilter;
